const showOptions = (options: any, translations: any, t: any) => {
  const optionsMapped: any = [];
  options.map((x: any) =>
    optionsMapped.push({
      value: x,
      label: `${t(`${translations.common}:${x}`)}`,
    })
  );
  return optionsMapped;
};
export default showOptions;
